<template>
    <div>
        <breadcrumb :routerList="[{to:'/establish/fanliJisuanYutiSaq',title:'返利计算预提'},{title:'返利预提详情'}]"/>
        <div class="h-content">

            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="客户名称" prop="agentNameLike">
							    <el-input v-model="q.agentNameLike" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="客户编码" prop="agentCodeLike">
							    <el-input v-model="q.agentCodeLike" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="链群" prop="rebateChainGroup">
							    <!--<el-input style="width:1.6rem" v-model="q.pipeiLianqunLike" placeholder="请输入"></el-input>-->
							    <brselect
										style="width: 100%;"
							            ref="rebateChainGroup"
							            clearable category="rebate_type"
							            :v="q.rebateChainGroup"
							            v-model="q.rebateChainGroup">
							    </brselect>
							</el-form-item>
							<el-form-item class="right-btn">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button @click="qingkong" class="h-btn h-formBtn h-bgwhite">重置</el-button>
							</el-form-item>
						</div>
                    </el-form>
                </div>
            </div>

            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table @selection-change="handleSelectionChange"
                          ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                          :border="true"
						  max-height="510"
                >
                    <el-table-column
                            type="selection"
							fixed
							width="45"
                    >
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="#"
							fixed
                            width="40">
                    </el-table-column>

                    <el-table-column
                            prop="year"
                            label="年"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="rebateChainGroup"
                            label="返利链群"
							:show-overflow-tooltip="true"
                            width="90">
                        <template slot-scope="scope">
                            {{scope.row.rebateChainGroup|dictname('rebate_type')}}
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="area"
                            label="区域"
							:show-overflow-tooltip="true"
                            width="80">
                    </el-table-column>
					<el-table-column
					        prop="customerId"
					        label="客户编码"
							:show-overflow-tooltip="true"
							fixed
					        width="120">
					</el-table-column>
                    <el-table-column
                            prop="customerName"
                            label="经销商姓名"
							:show-overflow-tooltip="true"
							fixed
                            min-width="180">
							<template slot-scope="scope">
							    <div style="text-align: left;">
							        {{scope.row.customerName}}
							    </div>
							</template>
                    </el-table-column>
                   
                    <el-table-column
                            prop="month"
                            label="月"
                            width="60">
                    </el-table-column>
                    <el-table-column
                            prop="goal"
                            label="目标"
							:show-overflow-tooltip="true"
                            width="90">
                    </el-table-column>
                    <el-table-column
                            prop="tongqi"
                            label="同期"
							:show-overflow-tooltip="true"
                            width="90">
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--prop="rebateCoefficient"-->
                            <!--label="月返利系数"-->
							<!--:show-overflow-tooltip="true"-->
                            <!--width="110">-->
                    <!--</el-table-column>-->


                    <el-table-column
                            prop="salesVolume"
                            label="销售额"
							:show-overflow-tooltip="true"
                            width="90">
                    </el-table-column>
                    <el-table-column
                            prop="rebateBase"
                            label="返利基数"
							:show-overflow-tooltip="true"
                            width="90">
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--prop="rebateAmount"-->
                            <!--label="返利金额"-->
							<!--:show-overflow-tooltip="true"-->
                            <!--width="100">-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                            <!--prop="completionRate"-->
                            <!--label="完成率"-->
							<!--:show-overflow-tooltip="true"-->
                            <!--width="100">-->
                    <!--</el-table-column>-->

                    <el-table-column
                            prop="jiduRebateCoefficient"
                            label="季度返利目标系数"
							:show-overflow-tooltip="true"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="jiduAddedRebate"
                            label="季度增值系数"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>

                    <el-table-column
                            v-if="1>2"
                            prop="fiBookCode"
                            label="基础合同id"
                            :show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>

                    <el-table-column
                            prop="jiduRealRebate"
                            label="季度实际系数"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="jiduMonthRebamount"
                            label="季度月返利金额"
							:show-overflow-tooltip="true"
                            width="140">
                    </el-table-column>
                </el-table>
                <div class="h-table h-mrt30">
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel" v-auth="'fanliyuti_daochu'">批量导出
                            </el-button>
                        </div>

                        <div class="h-pagination2">
                            <pagination :page="q" @query="handleFilter"/>
                        </div>

                        <div class="h-txtCenter h-mrt60">
                            <el-button class="h-btn h-bBtn h-bgblueQ2"   @click="goback">返回</el-button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        components: {},
        data() {
            return {
                //查询属性
                page: {
                    pageSize: 20,
                    pageNo: 1
                },
                q: {
                    rebateChainGroup: '',
                    agentNameLike: '',
                    agentCodeLike: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f: {
                    id: null, //
                    contractAgentId: null, // 经销商合同id
                    rebateChainGroup: null, // 返利链群：样本网、药品网、其他、血液网、疫苗网、试剂网、液氮罐、合计
                    customerId: null, // 客户id
                    type: null, // 1-月；2-季度
                    month: null, // 月用1234..季度用Q1Q2..
                    goal: null, // 目标
                    rebateCoefficient: null, // 月返利系数
                    jiduRebateCoefficient: null, // 季度返利目标系数
                    jiduAddedRebate: null, // 季度增值系数
                    realRebateAmount: null, // 实际月/季返利金额
                    salesVolume: null, // 销售额
                    rebateBase: null, // 返利基数
                    rebateAmount: null, // 返利金额
                    completionRate: null, // 完成率
                    cashAmount: null, // 兑现金额
                    tongqi: null, // 同期
                    add1: null, // 台阶
                    jiduRealRebate: null, // 季度实际系数
                    jiduMonthRebamount: null, // 季度月返利金额
                    tax: null, // 税率
                    cdate: null, // 创建时间
                    ldate: null, // 更新时间
                    cucode: null, // 创建人编码
                    cuname: null, // 创建人姓名
                    lucode: null, // 更新人编码
                    delflag: null, // 是否删除
                    cashable: null, // 应兑
                    cashed: null, // 已兑
                    tocash: null, // 未兑
                    add2: null, //
                    add3: null, //
                    rebateType: null, // 返利类型 传统ct、试剂网、血液网、疫苗网等
                    rebateSeries: null, // 返利系列：超低温产品、低温产品、恒温产品、生物安全产品、培养箱、其他产品、合计、U血液、U疫苗、U试剂、液氮罐
                    xiaoweiName: null, // 小微名称
                    xioweiCode: null, // 小微code
                    rebateAdvance: null, // 返利预提
                    year: null, // 年
                    liandongId: null, // 联动Id
                    isJisuan: null, // 是否计算0表示不计算，1表示计算
                    newRebateAmount: null, // 新生成的返利金额
                    isSap: null, // 是否传入SAP，1表示已经传入，0表示未传入
                    area: null, // 区域
                    customerName: null, // 经销商姓名
                    areaCode: null, // 区域编码
                },
                //table列表
                tableData: [],
                //表格
                multipleSelection: [],
                //操作标志
                optflag: 'save',
            }
        },
        created() {
            this.query();
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/establish/fanliJisuanYutiSaq' && from.path == '/establish/etYuTiList'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            query() {
                this.q.fiBookCode = this.$route.query.fiBookCode;
                this.q.year = this.$route.query.year;
                this.q.month = this.$route.query.month;
                ss.fanli.getYutiXiangqing(this.q).then(res => {
                    console.log(res, "开票数据")
                    this.tableData = res.records;
                    this.q.total = res.total;
                    for(var i=0;i<res.records.length;i++){
                        if(this.$route.query.fiBookCode){
                            res.records[i].fiBookCode = this.$route.query.fiBookCode
                        }
                    }
                })
            },
            goback(){
                this.$router.go(-1)
            },
            // //批量导出
            // exportExcel() {
            //     var idlist = [];
            //     this.multipleSelection.forEach(element => {
            //         idlist.push(element.id);
            //     });
            //     console.log(idlist,"AAAAAQQqq")
            //     updownfile.down("/api/swyl/v1/fanli/hetong/flJemsYuti/downfanliYutiExcel", idlist, "post", 'data');
            // },
            //返利预提明细批量导出
            exportExcel() {
                var idlist = [];
                this.q.fiBookCode = this.$route.query.fiBookCode;
                this.q.year = this.$route.query.year;
                this.q.month = this.$route.query.month;
                this.multipleSelection.forEach(element => {
                    idlist.push(element.customerId+","+element.year+","+element.month+","+element.fiBookCode);
                    console.log(idlist);
                });
                if (idlist.length != 0) {
                    console.log(idlist);
                    updownfile.down("/api/swyl/v1/demo/flJemsYuti/downloadExcelFlYutiByIdDetail", idlist, "post", 'data');
                } else {
                    updownfile.down("/api/swyl/v1/demo/flJemsYuti/downloadExcelFlYutiByEntityDetail", this.q, "post");
                }

            },








            handleFilter() {
                console.log("!!!!!!!!!!!")
                this.query();
            },
            qingkong() {
                this.q.rebateChainGroup = null;
                this.q.agentCodeLike = null;
                this.q.agentNameLike = null;
                this.query();
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection, "WWWWWWWWWW")
            },
        }
    }
</script>